export default "/images/trending-up.svg?ebfe9a72d68a3815181771098350599d";